/**
 * The key that opens the ⌘K palette, in a leaf module so the entry chunk's lazy half
 * (`command-palette.lazy.ts`) and the palette itself share one definition.
 */

/** ⌘K on a Mac, Ctrl+K elsewhere; not with Alt or Shift, which other shortcuts own. */
export const opensPalette = (event: { key: string; metaKey?: boolean; ctrlKey?: boolean; altKey?: boolean; shiftKey?: boolean }): boolean =>
  (event.metaKey === true || event.ctrlKey === true) && !event.altKey && !event.shiftKey && event.key.toLowerCase() === "k";
